import entities from 'entities';
import isEmpty from 'lodash/isEmpty';
import { marked } from 'marked';
import sanitizer from 'sanitize-html';
import TurndownService from 'turndown';

const _ = { isEmpty };

// unlike to-markdown, Turndown escapes list items: 1. becomes 1\.
// this overrides that behavior
TurndownService.prototype.escape = (t) => t;

marked.setOptions({
  renderer: new marked.Renderer(),
  gfm: true,
  breaks: true,
  pedantic: false,
  sanitize: false,
  smartLists: true,
  smartypants: true,
});

const turndownService = new TurndownService();
turndownService.keep('div');

const { allowedAttributes } = sanitizer.defaults;
allowedAttributes.iframe = ['width', 'height', 'src', 'frameborder', 'allowfullscreen'];
allowedAttributes.div = ['style'];
allowedAttributes.img = ['src', 'class', 'style', 'alt'];

const sanitizerOptions = {
  allowedTags: sanitizer.defaults.allowedTags.concat(['img', 'iframe', 'h2', 'address']),
  allowedAttributes,
};

export const HTMLCleaner = {
  clean(content) {
    if (_.isEmpty(content)) return '';
    const noparseBlocks = [];
    const contentExceptNoparseBlocks = content.replace(
      /\[noparse\](.*?)\[\/noparse\]/gs,
      (__, noparse) => `<span>[noparse-placeholder id=${noparseBlocks.push(noparse) - 1}]</span>`,
    );
    const cleanedString = sanitizer(
      entities.decodeHTML(contentExceptNoparseBlocks).replace(/(?:\r\n|\r|\n)/g, ' '),
      sanitizerOptions,
    ).replace(/\*/g, '\\*');
    const asMarkdown = turndownService
      .turndown(cleanedString)
      .split('\n')
      .map((line) => line.trim())
      .join('\n');
    const asHtml = marked(asMarkdown);
    return asHtml.replace(
      /(?:<span>)?\[noparse-placeholder id=(\d+)\](?:<\/span>)?/g,
      (__, id) => noparseBlocks[parseInt(id, 10)],
    );
  },
};
